import React from "react";
import { color } from "..";

const SpeechBalloon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 140 127" {...props}>
    <g transform="translate(-1632 -509)">
      <path
        d="M96.5,65.5c0,5.646-4.354,11-10,11h-62l-20,20v-82a9.847,9.847,0,0,1,10-10h72a9.847,9.847,0,0,1,10,10Z"
        transform="translate(1627.5 504.5)"
        fill={color.lightNitrogen500_Main}
        opacity="0.35"
      />
      <path
        className="b"
        d="M4.5,65.5c0,5.646,4.354,11,10,11h62l20,20v-82a9.847,9.847,0,0,0-10-10h-72a9.847,9.847,0,0,0-10,10Z"
        transform="translate(1675.5 539.5)"
        fill="#001a70"
        opacity="0.37"
      />
    </g>
  </svg>
);
export default SpeechBalloon;
